import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { returnErrors } from "../actions/errorAction";
import { auctionInvListFailure, auctionInvListSuccess } from "../actions/auctionInvAction";

const getLoginResult = (state) => state.loginReducer.loginResult;

function* asyncFetchAuctionInvSaga(action){
    try{
        const loginResult = yield select(getLoginResult);
        const accessToken = loginResult?.data?.auth_token?.access_token;

        let resauctionInvData = yield call(_api.fetchAuctionInvRequest,{
            reqAuctionId: action.payload.reqAuctionId,
            user_id: action.payload.user_id,
            accessToken: accessToken
        })
        yield put(auctionInvListSuccess({resauctionInvData}))
    }catch(e){
        yield put(auctionInvListFailure({error:e}))
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* fetchAuctionInvSaga(){
    yield takeLatest(types.FETCH_AUCTION_INV_REQUEST,asyncFetchAuctionInvSaga)
}
